import { authGet, awaitRequestJson } from '@/api/helpers'
import { AppRank, Template } from '@/types'

export function getTemplate(templateName: string, appRank: AppRank) {
  return awaitRequestJson<Template>(authGet(`template/${templateName}`, {}, appRank))
}
